import CustomSelect from '@/views/custom_select';
import PopperTooltip from '@/views/popper_tooltip';

pageLoad('pages_test', () => {
  new CustomSelect($('.b-input.test'));
  new PopperTooltip($('.b-tooltip-icon'));
});
